import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { RunningTimelineComponent } from "../running-timeline/running-timeline.component";
import { TimelineService } from '../../../../core/services/timeline.service';
import { PlaybackTimelineComponent } from '../playback-timeline/playback-timeline.component';
import { SessionOptionsService } from '../../../../core/services/session-option.service';

import { AlertComponent } from '../../alert/alert.component';
import { LiveTimelineComponent } from '../live-timeline/live-timeline.component';


const TIMELINE_SWITCH = 'TIMELINE_SWITCH';
const TIMELINE_PLAYBACK = 'playbackid';
const TIMELINE_MONITOR = 'monitorid';
const TIMELINE_LIVE = 'liveid';

@Component({
  selector: 'app-timelines-ui',
  standalone: true,
  imports: [RunningTimelineComponent, PlaybackTimelineComponent, LiveTimelineComponent],
  templateUrl: './timelines-ui.component.html',
  styleUrls: ['./timelines-ui.component.css'] // Fix: should be styleUrls (plural)
})
export class TimelinesUiComponent implements OnInit, OnDestroy {
  showTimeline = false;
  showLiveTime = false;
  showMonitorTime = false;
  sessionName: string = '';

  playbackid = TIMELINE_PLAYBACK;
  monitorid = TIMELINE_MONITOR;
  liveid = TIMELINE_LIVE;

  private subscription?: Subscription;
  private modeSubscription?: Subscription;
  @ViewChild('alertList') alertList!: AlertComponent;

  constructor(
    private timelineService: TimelineService,
    private sessionOptionsService: SessionOptionsService
  ) {}

  ngOnInit() {
    // Initialize from service data
    this.showTimeline = this.timelineService.data.showTimeline;
    this.showLiveTime = this.timelineService.data.showLiveTime;
    this.showMonitorTime = this.timelineService.data.showMonitorTime;
    this.sessionName = this.sessionOptionsService.getMode();

    // Subscribe to timeline switch event
    this.subscription = this.timelineService.timelineSwitch$.subscribe(() => {
      timer(500).subscribe(() => {
        this.showTimeline = this.timelineService.data.showTimeline;
        this.showLiveTime = this.timelineService.data.showLiveTime;
        this.showMonitorTime = this.timelineService.data.showMonitorTime;
      });
    });

    // Subscribe to session mode changes
    this.modeSubscription = this.sessionOptionsService.mode$.subscribe(mode => {
      this.sessionName = mode;
    });
  }
  onTimelineClick(event: { arcliveid: any, listid: any }) {
    setTimeout(() => {
      if (this.alertList) {
        this.alertList.handleTimelineClick(event);
      }
    }, 0);
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.modeSubscription) {
      this.modeSubscription.unsubscribe();
    }
  }

  toggleTimeline() {
    // Just toggling some values for demonstration
    this.timelineService.data.showTimeline = !this.timelineService.data.showTimeline;
    this.timelineService.data.showLiveTime = !this.timelineService.data.showLiveTime;
    this.timelineService.data.showMonitorTime = !this.timelineService.data.showMonitorTime;

    // Notify subscribers
   
  }
}
